import React from "react";

const OrganizationKeyVaults = () => {
    return <>OrganizationKeyVaults...</>;
};

export default OrganizationKeyVaults;
